module.exports = __webpack_public_path__ + "18b405e44365cb19f75321d51b81b711.png";